// removed by extract-text-webpack-plugin
module.exports = {"LastWords":"Footer__LastWords__27m7F","Logos":"Footer__Logos__2g24_","MyLogo":"Footer__MyLogo__vSs7f","FollowMe":"Footer__FollowMe__FfBki"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Footer/Footer.css
// module id = 246
// module chunks = 0